'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var debounce = require('debounce');

// Accumulate resize listeners and run them all as part of the resize handler.
// This way we only attach one actual event listener.
var resizeListeners = [];
var invokeResizeListeners = function invokeResizeListeners() {
  resizeListeners.forEach(function (listener) {
    return listener();
  });
};

var initialized = false;
function initializeListener() {
  if (initialized || typeof window == 'undefined') return;
  initialized = true;
  var onResize = debounce(invokeResizeListeners, 300);
  window.addEventListener('resize', onResize, false);
}

function survey(WrappedComponent) {
  initializeListener();

  var Surveyed = function (_React$Component) {
    _inherits(Surveyed, _React$Component);

    function Surveyed(props) {
      _classCallCheck(this, Surveyed);

      var _this = _possibleConstructorReturn(this, (Surveyed.__proto__ || Object.getPrototypeOf(Surveyed)).call(this, props));

      _this.state = {};
      _this.updateWidth = _this.updateWidth.bind(_this);
      _this.setContainerElement = _this.setContainerElement.bind(_this);
      resizeListeners.push(_this.updateWidth);
      return _this;
    }

    _createClass(Surveyed, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.updateWidth();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        resizeListeners.splice(resizeListeners.indexOf(this.updateWidth), 1);
      }
    }, {
      key: 'updateWidth',
      value: function updateWidth() {
        if (!this.container) return;
        var nextWidth = this.container.clientWidth;
        if (this.state.width !== nextWidth) {
          this.setState({ width: nextWidth });
        }
      }
    }, {
      key: 'setContainerElement',
      value: function setContainerElement(element) {
        this.container = element;
      }
    }, {
      key: 'render',
      value: function render() {
        var innards = null;
        if (this.state.width !== undefined) {
          innards = React.createElement(WrappedComponent, _extends({}, this.props, { width: this.state.width }));
        }

        return React.createElement(
          'div',
          { ref: this.setContainerElement },
          innards
        );
      }
    }]);

    return Surveyed;
  }(React.Component);

  Surveyed.WrappedComponent = WrappedComponent;
  return Surveyed;
}

survey.resurvey = invokeResizeListeners;

module.exports = survey;